import React, { useEffect, useState, useContext, useRef } from 'react'
import * as api from '../api'
import { ProfileContext } from '../../src/contexts/ProfileContext'
import { useForm, Controller } from "react-hook-form";
import {
    FormControl, Box, Stack, CircularProgress,
    TextField, Typography, Button, Alert, Grid, Backdrop, Container,
    Dialog,
    Slide,
    AppBar,
    Toolbar,
    Fade,
    DialogTitle,
    DialogContent
} from '@mui/material'
import { styled, useTheme } from '@mui/material/styles';
import { nanoid } from 'nanoid';
import CollectionsIcon from '@mui/icons-material/Collections';
import AddIcon from '@mui/icons-material/Add';
import { CardWithComment, CardResponse, DialogConfirm } from '../ui-component/'
import { ReactComponent as CameraIcon } from "../assets/images/logo/cameraPlus.svg"
import Zoom from 'react-medium-image-zoom'
import cancelIcon from "../assets/images/logo/cross.png"
import PhoneInput from 'react-phone-number-input/input'
import { useNavigate } from 'react-router-dom';
import * as dict from '../dictionary'
import { Cropper } from 'react-cropper';
import Webcam from 'react-webcam';
import { Close, PhotoCamera } from '@mui/icons-material';
import { checkProductType } from '../utils/checkProductType'
import { resizeImageFile } from '../utils/resizeImageFile'
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export const Suggestion = () => {
    const [dialogConfirm, setDialogConfirm] = useState(false)
    const [cameraTrigger, setCameraTrigger] = useState(false)
    const [shutterAction, setShutterAction] = useState(false)
    const [profile, setProfile] = useState(null);
    const [houseInfo, setHouseInfo] = useState(null)
    const [imgSaveArray, setImgSaveArray] = useState([])
    const [countSelected, setCountSelected] = useState(0)
    const [imgForCrop, setImgForCrop] = useState(null)
    const [cropPanelVisible, setCropPanelVisible] = useState(false)
    const [cropper, setCropper] = useState(null);
    const [alertResponds, setAlertResponds] = useState(false)
    const [typeAlert, setTypeAlert] = useState(null)
    const [loadingBackDrop, setLoadingBackDrop] = useState(false)
    const [alertNoImage, setAlertNoImage] = useState(false)
    const [projectDetail, setProjectDetail] = useState(null)
    const { control, handleSubmit, getValues } = useForm();
    const fileInputRef = useRef(null);
    const context = useContext(ProfileContext)
    const navigate = useNavigate()
    const onError = (errors) => console.log(errors)
    const theme = useTheme()
    const productType = checkProductType()

    const loadProjectDetail = async () => {
        setLoadingBackDrop(true)        
        let res = await api.getLatestProject({
            "project_id": houseInfo?.project_id,
            "line_id": profile?.line_id,
            "product_type": houseInfo?.product_type,
        })
        setProjectDetail(res?.data?.data||null)
        setLoadingBackDrop(false)
    }


    const handleCropImg = async () => {
        if (typeof cropper !== "undefined") {
            setLoadingBackDrop(true)

            const croppedCanvas = cropper.getCroppedCanvas({ width: 800, height: 600 });

            const blob = await new Promise((resolve) => {
                croppedCanvas.toBlob(resolve, "image/png", 1); // Adjust the quality if necessary
            });

            const imgUrl = croppedCanvas.toDataURL(); // Only generate once
            setImgSaveArray((prevArray) => [
                ...prevArray,
                {
                    id: nanoid(),
                    imgUrl,
                    binary: new File([blob], `${nanoid()}.png`, { type: "image/png" }),
                    selected: false,
                    value: ""
                }
            ]);

            setLoadingBackDrop(false);
            setCropPanelVisible(false)

            // setCameraTrigger(false)
        }
    }
    const handleOnSumbit = async () => {
        setLoadingBackDrop(true)

        if (imgSaveArray.length === 0) {
            setAlertNoImage(true)
            setLoadingBackDrop(false)
            return
        }


        let img = imgSaveArray
        let form = getValues()
        let tempImg = []

        
        await Promise.all(img.map(async item => {
            let res = await api.uploadImg(item.binary, {subject:"suggestion",product:"lineoa",company_id: houseInfo?.company_id})
            let data = res.data
            tempImg.push({
                "id": data.id,
                "name": data.name,
                "file_size": data.file_size,
                "content_type": data.content_type,
                "url": data.url,
                "description_en": "",
                "description_th": item.value,
                "sort_id": 0
            })
        }))

        let res = await api.suggestionCreate({
            "line_id": profile?.line_id,
            "product_type": houseInfo?.product_type,
            "title": form.title,
            "description": form.description,
            "mobile_no": '0' + form.mobile_no.slice(3),
            "project_id": houseInfo?.project_id,
            "unit_number": houseInfo?.unit_number,
            "house_number": houseInfo?.house_number,
            "file_gallery": tempImg,
            "email_recipients": productType==="rental"?projectDetail?.ProjectEmail:null
        })

        if (res?.data.status === 200) {
            setTypeAlert("success")
            setLoadingBackDrop(false)
            return setAlertResponds(true)
        }
        setLoadingBackDrop(false)
        setTypeAlert("error")
        return setAlertResponds(true)

    }
    const Input = styled('input')({
        display: 'none',
    });

    const uploadFileOnLocal = (file) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setImgSaveArray([...imgSaveArray, {
                id: nanoid(),
                imgUrl: reader.result,
                binary: file,
                selected: false,
                value: ""
            }])
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleDivClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files || []).slice(0, 3 - imgSaveArray.length);
        event.target.value = "";
        if (files.length === 0) return;
        setLoadingBackDrop(true)
        try {
            const images = await Promise.all(files.map((file) => resizeImageFile(file)));
            setImgSaveArray((prevArray) => [...prevArray, ...images].slice(0, 3));
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            setLoadingBackDrop(false)
        }
    };

    useEffect(() => {

        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }

        if (context.state?.houseInfo !== null) {
            setHouseInfo(context.state?.houseInfo)
        }

    }, [context])

    useEffect(()=>{
        if(projectDetail === null&&houseInfo!==null&&profile!==null&&productType==="rental"){
            loadProjectDetail()
        } 
    },[houseInfo,profile])
    return (
        <Container >

            <Box
                onSubmit={handleSubmit(handleOnSumbit, onError)}
                component="form"
                id="hook-form"
                sx={{ padding: 0.5, marginTop: 10 }}>
                <Stack direction="row" mt={1}>
                    <Typography variant="subtitle1" sx={{ color: "#FF5733" }}>
                        {dict.SuggestionForTeam_TXT[profile?.language]}
                    </Typography>
                </Stack>
                <Stack direction="column" spacing={3} mt={2}>
                    <Controller
                        control={control}
                        name="title"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <FormControl fullWidth>

                                <TextField 
                                    onChange={onChange}
                                    rows={8} 
                                    fullWidth 
                                    label={`${dict.Suggestion_Title_TXT[profile?.language]}*`} 
                                    id="fullWidth" 
                                    InputProps={{
                                        style: {
                                            borderRadius: "5px",
                                            border: "1px"
                                        }
                                    }}
                                    />
                                {

                                    error !== undefined && <Box sx={{ marginTop: 1 }}><Alert severity="error" >{dict.Pls_Name_Suggestion_TXT[profile?.language]}</Alert></Box>
                                }

                            </FormControl>)}
                    />
                    <Controller
                        control={control}
                        name="description"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <FormControl fullWidth>

                                <TextField 
                                onChange={onChange} 
                                multiline
                                rows={8} 
                                fullWidth 
                                label={`${dict.FeedBack_TXT[profile?.language]}*`} 
                                id="fullWidth"
                                InputProps={{
                                    style: {
                                        borderRadius: "5px",
                                        border: "1px"
                                    }
                                }}
                                />
                                {

                                    error !== undefined && <Box sx={{ marginTop: 1 }}><Alert severity="error" >{dict.Provide_FeedBack_TXT[profile?.language]}</Alert></Box>
                                }
                            </FormControl>)}
                    />
                    <Stack direction="row" mt={2}>
                        <Typography variant="subtitle1" >
                            {dict.Limit_Photo_TXT[profile?.language]}
                        </Typography>
                    </Stack>
                    <Box sx={{
                            [theme.breakpoints.up("md")]: {
                                height: "150px"
                            },
                            [theme.breakpoints.down("md")]: {
                                height: "25vw"
                            }
                        }}>

                    <Grid container direction="row" justifyContent="flex-start" spacing={2} sx={{ position: "absolute", width: "100%", paddingLeft: 2 }}>

                        {/* {
                            imgSaveArray.length > 0 && imgSaveArray.map((element, key) => <Grid item xs={4}>
                                <Controller
                                    control={control}
                                    name={`listImage-${key}`}
                                    defaultValue=""
                                    render={({ field: { onChange, onBlur, value } }) => (
                                        <FormControl fullWidth >

                                            <CardWithComment
                                                id={key}
                                                key={key}
                                                selected={element.selected}
                                                cardWidth={"100%"}
                                                cardHeight={"100%"}
                                                disabledComment={true}
                                                onSelected={() => {
                                                    let temp = [...imgSaveArray]
                                                    temp[key].selected = !temp[key].selected
                                                    setImgSaveArray(temp)

                                                    let count
                                                    if (temp[key].selected === true) {
                                                        count = countSelected + 1
                                                        return setCountSelected(count)
                                                    }
                                                    count = countSelected - 1
                                                    return setCountSelected(count)
                                                }}
                                                deleteIndex={() => setImgSaveArray(imgSaveArray.filter((r, index) => r.id !== element.id))}
                                                callBackInput={(val) => {
                                                    let temp = [...imgSaveArray]
                                                    temp[key].value = val
                                                    setImgSaveArray(temp)
                                                }}
                                                image={element.imgUrl}
                                                value={element.value}
                                            />
                                        </FormControl>
                                    )}
                                /> </Grid>
                            )
                        }
                        {imgSaveArray.length < 3 && <Grid item xs={4}> <label htmlFor="contained-button-file">
                            <Input accept="image/*" id="contained-button-file" multiple type="file"
                                onChange={(e) =>
                                    uploadFileOnLocal(e.target.files[0])
                                } />
                            <Box
                                id={"uploadPanel"}
                                sx={{

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100px",
                                    height: "100px",
                                    border: '1px dashed grey'
                                }}
                                onClick={() => { }}
                            >
                                <AddIcon sx={{ fontSize: 30 }} />
                                <CollectionsIcon sx={{ fontSize: 50 }} />
                            </Box></label>
                        </Grid>
                        }     */}
                         {
                                    imgSaveArray.map((element, key) => {
                                        return <Grid item sx={{ zIndex: 10 }} key={key}>
                                            <BoxHaveImg
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",

                                                }}>
                                                <CancelIcon src={cancelIcon} onClick={() => setImgSaveArray(imgSaveArray.filter((r, index) => r.id !== element.id))} />
                                                <Zoom>
                                                    <Box component="img" sx={{
                                                        [theme.breakpoints.up("md")]: {
                                                            width: "140px",
                                                            height: "140px",
                                                        },
                                                        [theme.breakpoints.down("md")]: {
                                                            width: "23vw",
                                                            height: "23vw",
                                                        },
                                                        objectFit: "cover",
                                                        marginTop: "4px"
                                                    }}
                                                        src={element.imgUrl}
                                                    >

                                                    </Box>
                                                    {/* <img src={element.imgUrl} sx={{
                                                        width: "23vw",
                                                        height: "23vw",
                                                        objectFit: "cover",
                                                        marginTop: "4px"
                                                    }} /> */}
                                                </Zoom>
                                            </BoxHaveImg>
                                        </Grid>
                                    })
                                }
                                {
                                    imgSaveArray.length < 3 &&
                                    <Grid item sx={{ zIndex: 10 }}>
                                        <BoxCamera
                                            onClick={handleDivClick}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}>
                                            <input
                                                id="cameraFileInput"
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                style={{ display: "none" }}
                                            />
                                            <CameraIcon style={{ width: "34.94px", height: "31.44px" }} fill={theme.palette.primary.main} />
                                            <Typography fontSize={"8px"} fontWeight={700} color={theme.palette.primary.main}>{dict.ADD_PHOTO_TXT[profile?.language || "th"]}</Typography>

                                        </BoxCamera>
                                    </Grid>
                                }                           
                         </Grid>
                         <Grid container direction="row" justifyContent="flex-start" spacing={2} sx={{ position: "absolute", zIndex: 1, width: "100%", paddingLeft: 2 }}>
                                <Grid item >
                                    <BoxNoImg />
                                </Grid>
                                <Grid item >
                                    <BoxNoImg />
                                </Grid>
                                <Grid item >
                                    <BoxNoImg />
                                </Grid>
                            </Grid>
                            </Box>
                    <Controller
                        control={control}
                        name="mobile_no"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <FormControl >
                                <Stack direction="row" >
                                    <Typography variant="subtitle1">{dict.Tel_Callback_TXT[profile?.language]}*</Typography>
                                </Stack>

                                <PhoneInput
                                    style={{ height: 30, paddingLeft: 4, marginTop: 15, marginBottom: 15 }}
                                    country={"TH"}
                                    withCountryCallingCode={false}
                                    value={value}
                                    onChange={onChange}
                                />
                                {

                                    error !== undefined && <Box sx={{ marginTop: 1 }}><Alert severity="error" >{dict.Input_MobileNumber_TXT[profile?.language]}</Alert></Box>
                                }
                            </FormControl>)}
                    />
                   {/* <>
                    {productType==="rental"?projectDetail?.ProjectEmail.split(",").map((r, index) => {                 
                       return(
                        <Grid container direction="row" justifyContent="flex-start" spacing={1}>                           
                       <Typography variant='body2'>{r}</Typography> 
                       </Grid>
                    )                    
                    }):[]}
                   </>  */}
                    <Button variant={"contained"} type={"submit"}>{dict.AcceptBtn_TXT[profile?.language]}</Button>
                </Stack>
                <br></br>
                <CardResponse
                    type={typeAlert}
                    titleDescription={dict.Recommend_Save_TXT[profile?.language]}
                    open={alertResponds}
                    onClose={() => {
                        setAlertResponds(false)
                        navigate(-1)
                    }}
                    onOk={() => {
                        setAlertResponds(false)
                        navigate(-1)

                    }}
                />
            </Box>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadingBackDrop}
            >
                <Stack alignItems={"center"} >
                    <Typography>{dict.Saving_Data_TXT[profile?.language]}</Typography>
                    <CircularProgress color="inherit" />
                </Stack>

            </Backdrop>
            <Dialog open={alertNoImage} onClose={() => setAlertNoImage(false)}>
                    <DialogTitle sx={{ color: "red" }}>{dict.UPLOAD_PHOTO_YET_TXT[profile?.language || "th"]}</DialogTitle>
                    <DialogContent>
                        <Typography variant={"subtitle1"} sx={{ color: "black" }}>{dict.UPLOAD_MINIMUM_TXT[profile?.language || "th"]}</Typography>
                    </DialogContent>
                </Dialog>
            <Dialog
                fullScreen
                open={cropPanelVisible}
                onClose={() => setCropPanelVisible(false)}
                TransitionComponent={Transition}
            >
                <Box sx={{ width: "100%", height: "100vh", marginTop: "20%" }}>
                    <Grid
                        container
                        direction="column"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant={"subtitle1"}> {dict.CROP_TXT[profile?.language || "th"]} </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ width: "100%", }}>
                                <Cropper
                                    src={imgForCrop}
                                    zoomTo={0}
                                    initialAspectRatio={1}
                                    preview=".img-preview"
                                    viewMode={1}
                                    minCropBoxHeight={10}
                                    minCropBoxWidth={10}
                                    background={false}
                                    responsive={true}
                                    autoCropArea={1}
                                    checkOrientation={false}
                                    style={{ height: 400, width: "100%" }}
                                    // Cropper.js options
                                    onInitialized={(instance) => {
                                        setCropper(instance);
                                    }}
                                    guides={true}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant={"contained"}
                                onClick={() => handleCropImg()}
                            >{dict.AcceptBtn_TXT[profile?.language || "th"]}</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Dialog>
            <DialogConfirm onClose={() => {
                setDialogConfirm(false)

            }
            } onOk={() => {
                setDialogConfirm(false)
                // setCameraTrigger(false)

            }} titleText={dict.TitleDialog_TXT[profile?.language || "th"]} titleDescription={dict.Description_TXT[profile?.language || "th"]} trigger={dialogConfirm} />

            <Dialog
                fullScreen
                TransitionComponent={Transition}
                open={cameraTrigger}
            >
                <AppBar sx={{
                    position: 'relative',
                    boxShadow: 'none',
                    height: 60,
                }}>
                    <Toolbar>
                        <Grid container item xs={1}>
                            <Close onClick={() => setCameraTrigger(false)} />
                        </Grid>
                        <Grid container item xs={10} direction="row"
                            justifyContent="center"
                        >
                            <Typography variant="h7" >
                                {dict.Capture_Defect_TXT[profile?.language || "th"]}
                            </Typography>
                        </Grid>

                    </Toolbar>
                </AppBar>

                <Fade in={shutterAction}>
                    <Box sx={{ width: "100%", mt: -5 }}>
                        <Webcam
                            width="100%"
                            height={"100%"}
                            screenshotFormat="image/jpeg"
                            videoConstraints={{

                                facingMode: { exact: "environment" }
                            }}
                        >
                            {({ getScreenshot }) => (
                                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                    <Button
                                        sx={{ width: "40%", mt: 1, mb: 1 }}
                                        variant='contained'
                                        onClick={() => {
                                            const imageSrc = getScreenshot()
                                            setShutterAction(false)
                                            setTimeout(() => {
                                                setShutterAction(true)
                                                setCropPanelVisible(true)
                                            }, 100)
                                            setImgForCrop(imageSrc)
                                        }}
                                    >
                                        <PhotoCamera sx={{ fontSize: 50 }} />
                                    </Button>
                                </Box>
                            )}
                        </Webcam>
                    </Box>
                </Fade>
            </Dialog>

        </Container>
    )
}


const CancelIcon = styled('img')(({ theme }) => ({

    position: "absolute",
    color: "red",
    [theme.breakpoints.up('md')]: {
        transform: "translate(72px, -72px)",
        width: "30px",
        height: "30px",
    },
    [theme.breakpoints.down('md')]: {
        transform: "translate(12vw, -12vw)",
        width: "5vw",
        height: "5vw",
    },
    zIndex: 2
}))

const BoxNoImg = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        width: "150px",
        height: "150px"
    },
    [theme.breakpoints.down("md")]: {
        width: "25vw",
        height: "25vw"
    },
    background: "linear-gradient(to right, #E0E0E0 60%, transparent 0%) top repeat-x , linear-gradient(#E0E0E0 60%, transparent 60%) right repeat-y, linear-gradient(to right, #E0E0E0 60%, transparent 0%) bottom repeat-x, linear-gradient(#E0E0E0 60%, transparent 0%) left repeat-y",
    backgroundSize: "20% 3px,3px 20%",
    borderRadius: "5%"
}))

const BoxHaveImg = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        width: "150px",
        height: "150px"
    },
    [theme.breakpoints.down("md")]: {
        width: "25vw",
        height: "25vw"
    },
    background: `linear-gradient(to right, ${theme.palette.primary.main} 100%, transparent 0%) top repeat-x , linear-gradient(${theme.palette.primary.main} 100%, transparent 60%) right repeat-y, linear-gradient(to right, ${theme.palette.primary.main} 1000%, transparent 0%) bottom repeat-x, linear-gradient(${theme.palette.primary.main} 100%, transparent 0%) left repeat-y`,
    backgroundSize: "20% 3px,3px 20%",
    borderRadius: "5%"
}))

const BoxCamera = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        width: "150px",
        height: "150px"
    },
    [theme.breakpoints.down("md")]: {
        width: "25vw",
        height: "25vw"
    },
    background: `linear-gradient(to right, ${theme.palette.primary.main} 60%, transparent 0%) top repeat-x , linear-gradient(${theme.palette.primary.main} 60%, transparent 60%) right repeat-y, linear-gradient(to right, ${theme.palette.primary.main} 60%, transparent 0%) bottom repeat-x, linear-gradient(${theme.palette.primary.main} 60%, transparent 0%) left repeat-y`,
    backgroundSize: "20% 3px,3px 20%",
    borderRadius: "5%"
}))